<template>
  <div class="box">
    <div v-if="loader" class="item-row products_list">
      <div
        class="spreadsheet-item-skeleton spreadsheet-item-skeleton-animate-wave"
        style="width: 25%"
      ></div>
      <div
        class="spreadsheet-item-skeleton spreadsheet-item-skeleton-animate-wave"
        style="width: 40%"
      ></div>
      <div
        class="spreadsheet-item-skeleton spreadsheet-item-skeleton-animate-wave"
        style="width: 10%"
      ></div>
    </div>

    <div v-if="$slots.default" class="item-row products_list">
      <slot></slot>
    </div>

    <div
      class="d-flex align-items-center justify-content-between item-row products_list"
      v-if="item && !loader"
    >
      <div>
        <h4 class="list-group-item-heading">{{ title }}</h4>
        <span v-if="item.user_email"
          ><b>Ação realizada por:</b> {{ item.user_email }}
        </span>
        <span v-if="item.created_at"><b>Data: </b> {{ parseDate(item.created_at) }}</span>
        <span v-if="item.created"><b>Data: </b> {{ parseDate(item.created) }}</span>
        <span v-if="item.total_rows"><b>total de linhas: </b> {{ item.total_rows }}</span>

        <div>
          <span :class="['badge', getStatus(item.status).badgeClass]">
            <i :class="['fa', getStatus(item.status).icon]" />
            {{ getStatus(item.status).name }}
          </span>
        </div>
      </div>

      <div>
        <div>
          <a
            v-if="hasExpired"
            class="icon"
            v-b-tooltip.hover
            @click.prevent="downloadSpreadsheet(JSON.parse(item.spreadsheet_links))"
            :title="$t('Planilha Disponivel')"
          >
            <i class="fa fa-download" v-bind:class="{ expiredNo: expiredNo }"></i>
          </a>
          <span v-else>Planilha não disponivel</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "spreadsheet-box-item",
  props: ["item", "title", "index", "loader"],
  data() {
    return {
      expiredNo: true,
      statusMapping: [
        "Na fila de processamento",
        "Finalizado",
        "Erro ao processar",
        "Processando",
      ],
    };
  },
  computed: {
    hasExpired() {
      const modified = this.item.created_at ? this.item.created_at : this.item.created;
      if (modified) {
        const startDT = moment(modified);
        const endDT = moment();

        const hourDiff = endDT.diff(startDT, "days");

        return Number(this.item.status) === 1 && hourDiff < 20;
      }

      return false;
    },
  },
  methods: {
    getStatus(statusInt) {
      const statusMapping = [
        {
          name: "Pendente",
          icon: "fa-spinner fa-pulse",
          badgeClass: "badge badge-secondary",
        },
        {
          name: "Planilha Enviada para o E-Mail",
          icon: "fa-check",
          badgeClass: "badge badge-success",
        },
        {
          name: "Erro ao processar",
          icon: "fa-exclamation-triangle",
          badgeClass: "badge badge-danger",
        },
        {
          name: "Processando",
          icon: "fa-spinner fa-pulse",
          badgeClass: "badge badge-info",
        },
      ];

      if (!this.hasExpired) {
        statusMapping[1] = {
          name: "Expirado",
          icon: "fa fa-hourglass-end",
          badgeClass: "badge badge-secondary",
        };
      }

      return statusInt <= statusMapping.length ? statusMapping[statusInt] : "Indefinido";
    },
    downloadSpreadsheet(linksArr = []) {
      if (linksArr && linksArr.length) {
        linksArr.map((url) => {
          window.open(url, "_blank").focus();
        });
      }
    },
    parseDate(dateString) {
      if (typeof dateString === "string") {
        //return moment(dateString).format("DD/MM/YYYY à[s] H[h]mm");
        dateString = dateString.replace("T", " ");
        dateString = dateString.replace(".000Z", "");
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const horas = date.getHours().toString().padStart(2, "0");
        const minutos = date.getMinutes().toString().padStart(2, "0");
        return `${day}/${month}/${year} às ${horas}:${minutos}h`;
      }
      return dateString;
    },
  },
};
</script>

<style scoped>
@keyframes shine {
  to {
    background-position:
      /*0 0,*/ 120% 0, /* move highlight to right */ 0 0;
  }
}
.spreadsheet-item-skeleton {
  position: relative;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.12);
  cursor: wait;
  mask-image: radial-gradient(#fff, #000);
  height: 1rem;
  margin-bottom: 0.25rem;
  border-radius: 0.25rem;

  background-size: 20px 41px, /* highlight */ 100% 41px;

  background-position: 0 0, /* highlight */ 0 0;
}

.spreadsheet-item-skeleton-animate-wave:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  background: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, 0.4), transparent);
  animation: shine 1.75s linear infinite;
}

.btn-circle {
  border-radius: 50px;
  position: fixed;
  z-index: 10;
  bottom: 25px;
  right: 20px;
}

.btn i {
  vertical-align: 0px !important;
}

.border-marketplaces {
  padding: 13px 0px 10px 15px;
  border: solid 1px #ebebeb;
  font-size: 13px;
  min-height: 100%;
}

.border-marketplaces h2 {
  font-size: 15px;
  font-weight: 600;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid #dee2e6;
}

th,
td {
  padding: 15px;
  text-align: left;
}

.text-green {
  color: #187412;
}

.table {
  margin-top: 10px;
}

.item-row {
  margin: 0px 10px 10px 0px;
  cursor: default;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgb(235, 235, 235);
  padding: 15px;
  border-radius: 3px;
  background: #fff;
}

.item-row:hover {
  box-shadow: 3px 3px 25px #d4d4d4;
}

small,
.small {
  font-size: 95%;
  font-weight: 400;
}

h4 {
  font-size: 1rem;
}

.action-buttons a {
  margin: 0 3px;
  font-size: 20px;
}
.expiredNo {
  color: #187412;
}
.box {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  width: 100%;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders/SpreadsheetsList/SpreadsheetBoxItem/SpreadsheetBoxItem.vue